/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setSplash.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * Import scrollTrigger.js bundle
 */
import { actionToSplash } from "./scrollTrigger/scrollTrigger-splash";

/**
 * hintBrowser
 * will-changeを外す
 */
var willChangeItem = document.querySelectorAll(".hintBrowser");

function hintBrowser() {
	for (let i = 0; i < willChangeItem.length; i++) {
		willChangeItem[i].classList.remove("hintBrowser");
	}
}

/**
 * スプラッシュ
 */
const setSplash = () => {
	window.addEventListener("DOMContentLoaded", () => {
		setTimeout(() => {
			//urlパラメーターに?id=homeがある場合はスプラッシュを表示しない
			let url = new URL(window.location.href);
			let param = url.searchParams.get("id");
			if (param == "home") {
			} else {
				if (window.document.body.classList.contains("home")) {
					var $myWindow = "visited";
					let splash = document.getElementById("splash");

					if (window.name.indexOf($myWindow) != -1) {
						splash.classList.add("visited");
					} else {
						window.name = $myWindow;
						splash.classList.add("active");
					}
				} else {
					// splash.classList.add("visited");
				}
			}
			// actionToSplash();
			hintBrowser();
		}, 1000);
	});
};

/**
 * ページ遷移アニメーション
 */
// const anchorLinks = document.querySelectorAll('a:not([href^="#"]):not([href^="javascript:void(0);"]):not([target="_blank"]):not([href^="tel:"])');
// const anchorLinksArr = Array.prototype.slice.call(anchorLinks);

// anchorLinksArr.forEach((link) => {
// 	link.addEventListener("click", (e) => {
// 		e.preventDefault();
// 		let url = e.currentTarget.href;
// 		let mask = document.getElementById("mask");

// 		if (url !== "") {
// 			mask.classList.add("active");

// 			setTimeout(() => {
// 				window.location = url;
// 			}, 800);
// 		}

// 		return false;
// 	});
// });

/**
 * Export.
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export { setSplash };
